import {
    Component,
    Input,
    Output,
    ViewChild,
    EventEmitter,
} from "@angular/core";
import { ConfirmModalComponent } from "./modals/confirm-modal.component";

@Component({
    selector: "zbd-request",
    templateUrl: "request.component.html",
    styles: [
        `
            .zbd-action-icon {
                width: 24px;
                height: 24px;
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                background-color: transparent;
                vertical-align: middle;
            }
            .zas-info-directive {
                width: 24px;
            }
            .tracking-action {
                display: inline-block;
            }
            div.put-right {
                right: unset;
            }
        `,
    ],
})
export class RequestComponent {
    @ViewChild("dropdown") dialog;
    @Input() public message: string;
    @Input() public icon: string;
    @Output() public accepted: EventEmitter<void> = new EventEmitter<void>();

    open() {
        ConfirmModalComponent.open(this.message, () => this.accepted.next());
    }
}
